import styled from 'styled-components';

const CustomSelectStyle = styled.div`
	--antSelectHeight: var(--sp8x);
	--selectPadding: var(--sp3x);

	position: relative;
	width: 100%;

	.ant-select-selector {
		height: var(--antSelectHeight) !important;
		padding: 0 var(--selectPadding) !important;
		display: flex;
		align-items: center;
	}

	.ant-select-clear {
		right: var(--selectPadding);
	}

	.ant-select-arrow {
		right: var(--selectPadding) !important;
	}

	.rc-virtual-list-holder {
		touch-action: none;
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--antSelectHeight: var(--sp6x);
		--selectPadding: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--antSelectHeight: var(--sp6x);
		--selectPadding: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--antSelectHeight: var(--sp6x);
		--selectPadding: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--antSelectHeight: var(--sp5x);
		--selectPadding: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--antSelectHeight: var(--sp5x);
		--selectPadding: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--antSelectHeight: var(--sp5x);
		--selectPadding: var(--sp1-5x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--antSelectHeight: var(--sp5x);
		--selectPadding: var(--sp1-5x);

		.ant-select-selector {
			font-size: 16px;
		}
	}
`;

export default CustomSelectStyle;
